/*
 *
 * Appointment reducer
 *
 */

import { fromJS } from 'immutable';
import { get } from 'lodash-es';
import {
  APPLY_REFERRAL,
  APPLY_REFERRAL_SUCCESS,
  CANCEL_USER_APPOINTMENT,
  CANCEL_USER_APPOINTMENT_FAILURE,
  CANCEL_USER_APPOINTMENT_SUCCESS,
  CHECK_GIFT_CODE,
  CHECK_GIFT_CODE_FAILURE,
  CHECK_GIFT_CODE_SUCCESS,
  CLEAR_APPOINTMENT_BOOKING_DATA,
  CLEAR_APPOINTMENT_DATA,
  CLEAR_APPOINTMENT_NET_VALUE,
  CLEAR_CROSS_SELECTED_SERVICE,
  CLEAR_CURRENT_SELECTED_DATE,
  CLEAR_CURRENT_THERAPIST_CLICKED,
  CLEAR_ENTERED_PHONE_NUMBER,
  CLEAR_ENTERED_PROMO_CODE,
  CLEAR_FILTER_STATE,
  CLEAR_GIFT_CODE,
  CLEAR_NEAREST_LOCATIONS,
  CLEAR_SELECTED_APPOINTMENT_SLOT,
  CLEAR_SELECTED_LOCATION,
  CLEAR_SELECTED_MASSAGE_TYPE,
  CLEAR_SELECTED_SERVICE,
  CLEAR_SELECTED_SERVICE_ADDON,
  CREATE_USER_APPOINTMENT,
  CREATE_USER_APPOINTMENT_FAILURE,
  CREATE_USER_APPOINTMENT_SUCCESS,
  FETCH_APPOINTMENTS,
  FETCH_APPOINTMENTS_FAILURE,
  FETCH_APPOINTMENTS_SUCCESS,
  FETCH_AVAILABLE_THERAPISTS,
  FETCH_AVAILABLE_THERAPISTS_FAILURE,
  FETCH_AVAILABLE_THERAPISTS_SUCCESS,
  FETCH_LOCATIONS,
  FETCH_LOCATIONS_FAILURE,
  FETCH_LOCATIONS_SUCCESS,
  FETCH_LOCATION_MORE_INFO,
  FETCH_LOCATION_MORE_INFO_FAILURE,
  FETCH_LOCATION_MORE_INFO_SUCCESS,
  FETCH_LOCATION_SERVICES,
  FETCH_LOCATION_SERVICES_FAILURE,
  FETCH_LOCATION_SERVICES_SUCCESS,
  FETCH_MASSAGE_TYPES,
  FETCH_MASSAGE_TYPES_FAILURE,
  FETCH_MASSAGE_TYPES_SUCCESS,
  FETCH_NEAREST_LOCATION,
  FETCH_NEAREST_LOCATION_FAILURE,
  FETCH_NEAREST_LOCATION_SUCCESS,
  FETCH_SERVICE_ADDONS,
  FETCH_SERVICE_ADDONS_FAILURE,
  FETCH_SERVICE_ADDONS_SUCCESS,
  FETCH_STATUS,
  FETCH_STATUS_FAILURE,
  FETCH_STATUS_SUCCESS,
  FETCH_USER_COMPLETED_APPOINTMENTS,
  FETCH_USER_COMPLETED_APPOINTMENTS_FAILURE,
  FETCH_USER_COMPLETED_APPOINTMENTS_SUCCESS,
  FETCH_USER_PRESSURE,
  FETCH_USER_PRESSURE_FAILURE,
  FETCH_USER_PRESSURE_SUCCESS,
  FETCH_USER_SERVICE_ADDONS,
  FETCH_USER_SERVICE_ADDONS_FAILURE,
  FETCH_USER_SERVICE_ADDONS_SUCCESS,
  GEOLOCATION_API_STATUS,
  GET_IP_ADDRESS,
  GET_IP_ADDRESS_FAILURE,
  GET_IP_ADDRESS_SUCCESS,
  GET_LIABILITY_WAIVER,
  GET_LIABILITY_WAIVER_FAILURE,
  GET_LIABILITY_WAIVER_SUCCESS,
  RETRY_APPOINTMENT_CHARGE,
  RETRY_APPOINTMENT_CHARGE_FAILURE,
  RETRY_APPOINTMENT_CHARGE_SUCCESS,
  SEND_REQUIRED_GOVT_INFO,
  SEND_REQUIRED_GOVT_INFO_FAILURE,
  SEND_REQUIRED_GOVT_INFO_SUCCESS,
  SEND_SIGNATURE,
  SEND_SIGNATURE_FAILURE,
  SEND_SIGNATURE_SUCCESS,
  SET_APPOINTMENT_NET_VALUE,
  SET_BOOKING_FLOW,
  SET_BOOKING_ATTRIBUTION,
  SET_BUYING_REGULAR_MEMBERSHIP_FLOW,
  SET_CROSS_SELECTED_SERVICE,
  SET_CURRENT_SELECTED_DATE,
  SET_CURRENT_THERAPIST_CLICKED,
  SET_ENTERED_PHONE_NUMBER,
  SET_ENTERED_PROMO_CODE,
  SET_FILTER_STATE,
  SET_NOT_AVAILABILE_TILL_DATE,
  SET_SELECTED_APPOINTMENT_SLOT,
  SET_SELECTED_LOCATION,
  SET_SELECTED_MASSAGE_TYPE,
  SET_SELECTED_SERVICE,
  SET_SELECTED_SERVICE_ADDON,
  SET_THERAPIST_ADDONS,
  SET_BOOKING_ADDONS_EXPLICIT_OPT_OUT,
  SET_BOOKING_MASSAGE_PREFERENCES,
  SET_BOOKING_SELECTED_FREE_ADDONS,
  SET_BOOKING_SELECTED_PAID_ADDONS,
  SUGGESTED_TIP_AMOUNT,
  SUGGESTED_TIP_AMOUNT_FAILURE,
  SUGGESTED_TIP_AMOUNT_SUCCESS,
  UPDATE_APPOINTMENT_TEXT,
  UPDATE_APPOINTMENT_TEXT_ERROR,
  UPDATE_APPOINTMENT_TEXT_SUCCESS,
  UPDATE_USER_PRESSURE,
  UPDATE_USER_PRESSURE_FAILURE,
  UPDATE_USER_PRESSURE_SUCCESS,
  UPDATE_USER_SERVICE_ADDONS,
  UPDATE_USER_SERVICE_ADDONS_FAILURE,
  UPDATE_USER_SERVICE_ADDONS_SUCCESS,
} from './constants';
import { GEO_LOCATION_STATUS } from '../../utils/common';
import {
  isZeroPriceAddon,
  mergeBookingPaidAddonLists,
  rematchAddonsFromCatalog,
} from '../../utils/appointment-addons';

export const initialState = fromJS({
  locations: [],
  fetchingLocations: false,
  fetchingLocationsError: null,
  serviceAddons: [],
  serviceAddonsLocationId: null,
  fetchingServiceAddons: false,
  fetchingServiceAddonsError: null,
  selectedServiceAddon: null,
  selectedLocation: {},
  fetchingLocationServices: false,
  fetchingLocationServicesError: false,
  locationServices: {},
  selectedService: {},
  massageTypes: [],
  fetchingMassageTypes: false,
  fetchingMassageTypesError: null,
  selectedMassageType: {},
  availableSlots: [],
  fetchingAvailableSlots: false,
  fetchingAvailableSlotsError: null,
  selectedAppointmentSlot: {},
  giftCodeResult: {},
  giftCardCodeResult: {},
  promoCodeResult: {},
  checkingGiftCode: false,
  checkingGiftCodeKind: null,
  checkingGiftCodeError: null,
  checkingGiftCodeErrorByKind: { gift_card: null, promo: null },
  createUserAppointmentResult: {},
  creatingUserAppointment: false,
  creatingUserAppointmentError: null,
  pressurePreferences: [],
  fetchingPressurePreferences: false,
  fetchingPressurePreferencesError: null,
  bookingFlow: null,
  bookingAttribution: {},
  fetchingUserCompletedAppointments: false,
  fetchingUSerAppointmentsError: null,
  userCompletedAppointments: [],
  fetchingAppointments: false,
  fetchingAppointmentsError: null,
  myAppointments: [],
  cancellingUserAppointment: false,
  cancellingUserAppointmentError: null,
  cancelUserAppointmentResult: {},
  updatingAppointmentText: false,
  updatingAppointmentTextError: null,
  appointmentText: {},
  filterState: {},
  currentTherapistClicked: {},
  currentSelectedDate: null,
  enteredPhoneNumber: null,
  appointmentNetValue: null,
  enteredPromoCode: null,
  retryingAppointmentCharge: false,
  retryingAppointmentChargeError: null,
  retryAppointmentChargeResult: {},
  applyReferral: false,
  referralResult: null,
  fetchingStatus: false,
  fetchingStatusError: null,
  statusRequestId: 0,
  myStatus: [],
  updatingPressurePreferences: false,
  updatingPressurePreferencesError: null,
  updatePressurePreferencesResult: {},
  notAvailableTillDate: null,
  nearestLocations: [],
  fetchingNearestLocations: false,
  fetchingNearestLocationsError: null,
  liabilityWaiver: [],
  fetchingLiabilityWaiver: false,
  fetchingLiabilityWaiverError: null,
  signature: [],
  sendingSignature: false,
  sendingSignatureError: null,
  suggestedTipAmount: {},
  fetchingSuggestedTipAmount: false,
  suggestedTipAmountError: null,
  fetchingIpAddress: false,
  ipAddress: { ip: '' },
  ipAddressError: null,
  geoLocationStatus: GEO_LOCATION_STATUS.GRANTED,
  sendingRequiredGovtInfo: false,
  sendingRequiredGovtInfoError: null,
  requiredGovtInfo: {},
  therapistAddonsList: [],
  bookingAddonsExplicitOptOut: false,
  bookingMassagePreferences: {},
  bookingSelectedFreeAddons: [],
  bookingSelectedPaidAddons: [],
});

function reduceCheckGiftCode(state, action) {
  return state.withMutations(s => {
    s.set('checkingGiftCode', true).set(
      'checkingGiftCodeKind',
      action.codeKind || null,
    );
    if (action.codeKind === 'gift_card') {
      s.setIn(['checkingGiftCodeErrorByKind', 'gift_card'], null);
      return;
    }
    if (action.codeKind === 'promo') {
      s.setIn(['checkingGiftCodeErrorByKind', 'promo'], null);
      return;
    }
    s.set('checkingGiftCodeError', null).set('giftCodeResult', fromJS({}));
  });
}

function reduceCheckGiftCodeSuccess(state, action) {
  return state.withMutations(s => {
    const wasChecking = s.get('checkingGiftCode');
    const expectedKind = s.get('checkingGiftCodeKind');
    s.set('checkingGiftCode', false)
      .set('checkingGiftCodeKind', null)
      .set('checkingGiftCodeError', null);

    // Stale validate after clearGiftCode / navigation — do not re-apply.
    if (!wasChecking) {
      return;
    }
    const { codeKind } = action.result || {};
    if (expectedKind && codeKind && expectedKind !== codeKind) {
      return;
    }
    // A late validate response must not re-apply codes after a successful book.
    if (s.getIn(['createUserAppointmentResult', 'success'])) {
      return;
    }
    if (codeKind === 'gift_card') {
      s.set('giftCardCodeResult', fromJS(action.result)).setIn(
        ['checkingGiftCodeErrorByKind', 'gift_card'],
        null,
      );
      return;
    }
    if (codeKind === 'promo') {
      s.set('promoCodeResult', fromJS(action.result)).setIn(
        ['checkingGiftCodeErrorByKind', 'promo'],
        null,
      );
      return;
    }
    s.set('giftCodeResult', fromJS(action.result));
  });
}

function reduceCheckGiftCodeFailure(state, action) {
  return state.withMutations(s => {
    const wasChecking = s.get('checkingGiftCode');
    const expectedKind = s.get('checkingGiftCodeKind');
    s.set('checkingGiftCode', false).set('checkingGiftCodeKind', null);

    // Stale validate failure after clearGiftCode — ignore.
    if (!wasChecking) {
      return;
    }
    if (expectedKind && action.codeKind && expectedKind !== action.codeKind) {
      return;
    }
    if (action.codeKind === 'gift_card') {
      s.set('giftCardCodeResult', fromJS({})).setIn(
        ['checkingGiftCodeErrorByKind', 'gift_card'],
        action.error,
      );
      return;
    }
    if (action.codeKind === 'promo') {
      s.set('promoCodeResult', fromJS({})).setIn(
        ['checkingGiftCodeErrorByKind', 'promo'],
        action.error,
      );
      return;
    }
    s.set('checkingGiftCodeError', action.error).set(
      'giftCodeResult',
      fromJS({}),
    );
  });
}

function reduceClearGiftCode(state, action) {
  return state.withMutations(s => {
    s.set('checkingGiftCode', false).set('checkingGiftCodeKind', null);
    if (action.errorsOnly) {
      if (action.codeKind === 'gift_card') {
        s.setIn(['checkingGiftCodeErrorByKind', 'gift_card'], null);
        return;
      }
      if (action.codeKind === 'promo') {
        s.setIn(['checkingGiftCodeErrorByKind', 'promo'], null);
        return;
      }
      s.set('checkingGiftCodeError', null).set(
        'checkingGiftCodeErrorByKind',
        fromJS({ gift_card: null, promo: null }),
      );
      return;
    }
    if (action.codeKind === 'gift_card') {
      s.set('giftCardCodeResult', fromJS({})).setIn(
        ['checkingGiftCodeErrorByKind', 'gift_card'],
        null,
      );
      return;
    }
    if (action.codeKind === 'promo') {
      s.set('promoCodeResult', fromJS({})).setIn(
        ['checkingGiftCodeErrorByKind', 'promo'],
        null,
      );
      return;
    }
    s.set('checkingGiftCodeError', null)
      .set('giftCodeResult', fromJS({}))
      .set('giftCardCodeResult', fromJS({}))
      .set('promoCodeResult', fromJS({}))
      .set(
        'checkingGiftCodeErrorByKind',
        fromJS({ gift_card: null, promo: null }),
      );
  });
}

function appointmentReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_LOCATIONS:
      return state.withMutations(s => {
        s.set('fetchingLocations', true)
          .set('fetchingLocationsError', null)
          .set('locations', fromJS([]));
      });

    case FETCH_LOCATIONS_SUCCESS:
      return state.withMutations(s => {
        s.set('fetchingLocations', false)
          .set('fetchingLocationsError', null)
          .set('locations', fromJS(action.result));
      });

    case FETCH_LOCATIONS_FAILURE:
      return state.withMutations(s => {
        s.set('fetchingLocations', false)
          .set('fetchingLocationsError', action.error)
          .set('locations', fromJS([]));
      });

    case FETCH_SERVICE_ADDONS:
      return state.withMutations(s => {
        s.set('fetchingServiceAddons', true).set(
          'fetchingServiceAddonsError',
          null,
        );
        const prevLoc = s.get('serviceAddonsLocationId');
        const incoming = action.locationId;
        const sameLocation =
          incoming != null &&
          prevLoc != null &&
          String(incoming) === String(prevLoc);
        if (!sameLocation) {
          s.set('serviceAddons', fromJS([])).set(
            'serviceAddonsLocationId',
            null,
          );
        }
      });

    case FETCH_SERVICE_ADDONS_SUCCESS:
      return state.withMutations(s => {
        s.set('fetchingServiceAddons', false)
          .set('fetchingServiceAddonsError', null)
          .set('serviceAddons', fromJS(action.result))
          .set(
            'serviceAddonsLocationId',
            action.locationId != null ? action.locationId : null,
          );
        const list = action.result || [];
        const sel = s.get('selectedServiceAddon');
        const selJs = sel && typeof sel.toJS === 'function' ? sel.toJS() : null;
        if (selJs && list.length) {
          const match = list.find(a => {
            if (!a) return false;
            if (selJs.id != null && String(a.id) === String(selJs.id)) {
              return true;
            }
            const prevTypeId = get(selJs, 'addon_type.id');
            const nextTypeId = get(a, 'addon_type.id');
            if (
              prevTypeId != null &&
              nextTypeId != null &&
              String(prevTypeId) === String(nextTypeId)
            ) {
              return true;
            }
            return false;
          });
          if (match) {
            s.set('selectedServiceAddon', fromJS(match));
          }
        }
        const freeListRaw = s.get('bookingSelectedFreeAddons');
        const freeJs =
          freeListRaw && typeof freeListRaw.toJS === 'function'
            ? freeListRaw.toJS()
            : [];
        if (Array.isArray(freeJs) && freeJs.length && list.length) {
          s.set(
            'bookingSelectedFreeAddons',
            fromJS(rematchAddonsFromCatalog(freeJs, list)),
          );
        }
        const paidListRaw = s.get('bookingSelectedPaidAddons');
        const paidJs =
          paidListRaw && typeof paidListRaw.toJS === 'function'
            ? paidListRaw.toJS()
            : [];
        if (Array.isArray(paidJs) && paidJs.length && list.length) {
          s.set(
            'bookingSelectedPaidAddons',
            fromJS(rematchAddonsFromCatalog(paidJs, list)),
          );
        }
      });

    case FETCH_SERVICE_ADDONS_FAILURE:
      return state.withMutations(s => {
        s.set('fetchingServiceAddons', false).set(
          'fetchingServiceAddonsError',
          action.error,
        );
      });

    case SET_SELECTED_SERVICE_ADDON:
      return state.withMutations(s => {
        s.set(
          'selectedServiceAddon',
          action.addon ? fromJS(action.addon) : fromJS({}),
        );
        if (action.addon && action.addon.addon_type) {
          s.set('bookingAddonsExplicitOptOut', false);
          if (!isZeroPriceAddon(action.addon)) {
            const paidRaw = s.get('bookingSelectedPaidAddons');
            const paidJs =
              paidRaw && typeof paidRaw.toJS === 'function'
                ? paidRaw.toJS()
                : [];
            s.set(
              'bookingSelectedPaidAddons',
              fromJS(mergeBookingPaidAddonLists(paidJs, [action.addon])),
            );
          }
        }
      });

    case CLEAR_SELECTED_SERVICE_ADDON:
      return state.withMutations(s => {
        s.set('selectedServiceAddon', {});
      });

    case SET_BOOKING_ADDONS_EXPLICIT_OPT_OUT:
      return state.set('bookingAddonsExplicitOptOut', !!action.optedOut);

    case SET_BOOKING_MASSAGE_PREFERENCES:
      return state.set('bookingMassagePreferences', fromJS(action.preferences));

    case SET_BOOKING_SELECTED_FREE_ADDONS:
      return state.set(
        'bookingSelectedFreeAddons',
        fromJS(action.addons || []),
      );

    case SET_BOOKING_SELECTED_PAID_ADDONS:
      return state.set(
        'bookingSelectedPaidAddons',
        fromJS(action.addons || []),
      );

    case SET_THERAPIST_ADDONS:
      return state.withMutations(s => {
        s.set('therapistAddonsList', fromJS(action.addon_type_ids));
      });

    case FETCH_USER_SERVICE_ADDONS:
      return state.withMutations(s => {
        s.set('fetchingUserServiceAddons', true)
          .set('fetchingUserServiceAddonsError', null)
          .set('userServiceAddons', fromJS([]));
      });

    case FETCH_USER_SERVICE_ADDONS_SUCCESS:
      return state.withMutations(s => {
        s.set('fetchingUserServiceAddons', false)
          .set('fetchingUserServiceAddonsError', null)
          .set('userServiceAddons', fromJS(action.result));
      });

    case FETCH_USER_SERVICE_ADDONS_FAILURE:
      return state.withMutations(s => {
        s.set('fetchingUserServiceAddons', false)
          .set('fetchingUserServiceAddonsError', action.error)
          .set('userServiceAddons', fromJS([]));
      });

    case UPDATE_USER_SERVICE_ADDONS:
      return state.withMutations(s => {
        s.set('updatingServiceAddons', true)
          .set('updatingServiceAddonsError', null)
          .set('userServiceAddons', fromJS([]));
      });

    case UPDATE_USER_SERVICE_ADDONS_SUCCESS:
      return state.withMutations(s => {
        s.set('updatingServiceAddons', false)
          .set('updatingServiceAddonsError', null)
          .set('userServiceAddons', fromJS(action.result));
      });

    case UPDATE_USER_SERVICE_ADDONS_FAILURE:
      return state.withMutations(s => {
        s.set('updatingServiceAddons', false)
          .set('updatingServiceAddonsError', action.error)
          .set('userServiceAddons', fromJS([]));
      });

    case SET_SELECTED_LOCATION:
      return state.withMutations(s => {
        s.set('selectedLocation', fromJS(action.location))
          .set('bookingAddonsExplicitOptOut', false)
          .set('selectedServiceAddon', fromJS({}))
          .set('bookingMassagePreferences', fromJS({}))
          .set('bookingSelectedFreeAddons', fromJS([]))
          .set('bookingSelectedPaidAddons', fromJS([]))
          .set('serviceAddons', fromJS([]))
          .set('serviceAddonsLocationId', null);
      });

    case FETCH_LOCATION_SERVICES:
      return state.withMutations(s => {
        s.set('fetchingLocationServices', true)
          .set('fetchingLocationServicesError', null)
          .set('locationServices', fromJS({}));
      });

    case FETCH_LOCATION_SERVICES_SUCCESS:
      return state.withMutations(s => {
        s.set('fetchingLocationServices', false)
          .set('fetchingLocationServicesError', null)
          .set('locationServices', fromJS(action.result));
      });

    case FETCH_LOCATION_SERVICES_FAILURE:
      return state.withMutations(s => {
        s.set('fetchingLocationServices', false)
          .set('fetchingLocationServicesError', action.error)
          .set('locationServices', fromJS({}));
      });

    case FETCH_LOCATION_MORE_INFO:
      return state.withMutations(s => {
        s.set('fetchingLocationMoreInfo', true)
          .set('fetchingLocationMoreInfoError', null)
          .set('locationMoreInfo', fromJS({}));
      });

    case FETCH_LOCATION_MORE_INFO_SUCCESS:
      return state.withMutations(s => {
        s.set('fetchingLocationMoreInfo', false)
          .set('fetchingLocationMoreInfoError', null)
          .set('locationMoreInfo', fromJS(action.result));
      });

    case FETCH_LOCATION_MORE_INFO_FAILURE:
      return state.withMutations(s => {
        s.set('fetchingLocationMoreInfo', false)
          .set('fetchingLocationMoreInfoError', action.error)
          .set('locationServices', fromJS({}));
      });

    case SET_SELECTED_SERVICE:
      return state.withMutations(s => {
        s.set('selectedService', fromJS(action.service));
      });

    case SET_CROSS_SELECTED_SERVICE:
      return state.withMutations(s => {
        s.set('crossSelectedService', fromJS(action.service));
      });

    case FETCH_MASSAGE_TYPES:
      return state.withMutations(s => {
        s.set('fetchingMassageTypes', true)
          .set('fetchingMassageTypesError', null)
          .set('massageTypes', fromJS([]));
      });

    case FETCH_MASSAGE_TYPES_SUCCESS:
      return state.withMutations(s => {
        s.set('fetchingMassageTypes', false)
          .set('fetchingMassageTypesError', null)
          .set('massageTypes', fromJS(action.result));
      });

    case FETCH_MASSAGE_TYPES_FAILURE:
      return state.withMutations(s => {
        s.set('fetchingMassageTypes', false)
          .set('fetchingMassageTypesError', action.error)
          .set('massageTypes', fromJS([]));
      });

    case SET_SELECTED_MASSAGE_TYPE:
      return state.withMutations(s => {
        s.set('selectedMassageType', fromJS(action.massageType));
      });

    case FETCH_AVAILABLE_THERAPISTS:
      return state.withMutations(s => {
        s.set('fetchingAvailableSlots', true)
          .set('fetchingAvailableSlotsError', null)
          .set('availableSlots', fromJS([]));
      });

    case FETCH_AVAILABLE_THERAPISTS_SUCCESS:
      return state.withMutations(s => {
        s.set('fetchingAvailableSlots', false)
          .set('fetchingAvailableSlotsError', null)
          .set('availableSlots', fromJS(action.result));
      });

    case FETCH_AVAILABLE_THERAPISTS_FAILURE:
      return state.withMutations(s => {
        s.set('fetchingAvailableSlots', false)
          .set('fetchingAvailableSlotsError', action.error)
          .set('availableSlots', fromJS([]));
      });

    case SET_NOT_AVAILABILE_TILL_DATE:
      return state.withMutations(s => {
        s.set('notAvailableTillDate', fromJS(action.result));
      });

    case SET_SELECTED_APPOINTMENT_SLOT:
      return state.withMutations(s => {
        s.set('selectedAppointmentSlot', fromJS(action.appointmentSlot));
      });

    case CHECK_GIFT_CODE:
      return reduceCheckGiftCode(state, action);

    case CHECK_GIFT_CODE_SUCCESS:
      return reduceCheckGiftCodeSuccess(state, action);

    case CHECK_GIFT_CODE_FAILURE:
      return reduceCheckGiftCodeFailure(state, action);

    case CLEAR_GIFT_CODE:
      return reduceClearGiftCode(state, action);

    case CREATE_USER_APPOINTMENT:
      return state.withMutations(s => {
        s.set('creatingUserAppointment', true)
          .set('creatingUserAppointmentError', null)
          .set('createUserAppointmentResult', fromJS({}));
      });

    case CREATE_USER_APPOINTMENT_SUCCESS:
      return state.withMutations(s => {
        s.set('creatingUserAppointment', false)
          .set('creatingUserAppointmentError', null)
          .set('createUserAppointmentResult', fromJS(action.result))
          .set('bookingAttribution', fromJS({}))
          // Reset checkout codes so the next booking does not reuse them.
          .set('giftCodeResult', fromJS({}))
          .set('giftCardCodeResult', fromJS({}))
          .set('promoCodeResult', fromJS({}))
          .set('checkingGiftCode', false)
          .set('checkingGiftCodeKind', null)
          .set('checkingGiftCodeError', null)
          .set(
            'checkingGiftCodeErrorByKind',
            fromJS({ gift_card: null, promo: null }),
          );
      });

    case CREATE_USER_APPOINTMENT_FAILURE:
      return state.withMutations(s => {
        s.set('creatingUserAppointment', false)
          .set('creatingUserAppointmentError', action.error)
          .set('createUserAppointmentResult', fromJS({}));
      });

    case CLEAR_APPOINTMENT_BOOKING_DATA:
      return state.withMutations(s => {
        s.set('creatingUserAppointment', false)
          .set('creatingUserAppointmentError', null)
          .set('createUserAppointmentResult', fromJS({}));
      });

    case CLEAR_SELECTED_LOCATION:
      return state.withMutations(s => {
        s.set('selectedLocation', fromJS({}))
          .set('serviceAddons', fromJS([]))
          .set('serviceAddonsLocationId', null);
      });

    case CLEAR_CROSS_SELECTED_SERVICE:
      return state.withMutations(s => {
        s.set('crossSelectedService', {});
      });

    case CLEAR_SELECTED_SERVICE:
      return state.withMutations(s => {
        s.set('selectedService', {});
      });

    case CLEAR_SELECTED_APPOINTMENT_SLOT:
      return state.withMutations(s => {
        s.set('selectedAppointmentSlot', {});
      });

    case CLEAR_SELECTED_MASSAGE_TYPE:
      return state.withMutations(s => {
        s.set('selectedMassageType', {});
      });

    case FETCH_USER_PRESSURE:
      return state.withMutations(s => {
        s.set('fetchingPressurePreferences', true)
          .set('fetchingPressurePreferencesError', null)
          .set('pressurePreferences', fromJS([]));
      });

    case FETCH_USER_PRESSURE_SUCCESS:
      return state.withMutations(s => {
        s.set('fetchingPressurePreferences', false)
          .set('fetchingPressurePreferencesError', null)
          .set('pressurePreferences', fromJS(action.result));
      });

    case FETCH_USER_PRESSURE_FAILURE:
      return state.withMutations(s => {
        s.set('fetchingPressurePreferences', false)
          .set('fetchingPressurePreferencesError', action.error)
          .set('pressurePreferences', fromJS([]));
      });

    case UPDATE_USER_PRESSURE:
      return state.withMutations(s => {
        s.set('updatingPressurePreferences', true)
          .set('updatingPressurePreferencesError', null)
          .set('pressurePreferences', fromJS([]));
      });

    case UPDATE_USER_PRESSURE_SUCCESS:
      return state.withMutations(s => {
        s.set('updatingPressurePreferences', false)
          .set('updatingPressurePreferencesError', null)
          .set('pressurePreferences', fromJS(action.result));
      });

    case UPDATE_USER_PRESSURE_FAILURE:
      return state.withMutations(s => {
        s.set('updatingPressurePreferences', false)
          .set('updatingPressurePreferencesError', action.error)
          .set('pressurePreferences', fromJS([]));
      });

    case UPDATE_APPOINTMENT_TEXT:
      return state.withMutations(s => {
        s.set('updatingAppointmentText', true)
          .set('updatingAppointmentTextError', null)
          .set('appointmentText', fromJS({}));
      });

    case UPDATE_APPOINTMENT_TEXT_SUCCESS:
      return state.withMutations(s => {
        s.set('updatingAppointmentText', false)
          .set('updatingAppointmentTextError', null)
          .set('appointmentText', fromJS(action.result));
      });

    case UPDATE_APPOINTMENT_TEXT_ERROR:
      return state.withMutations(s => {
        s.set('updatingAppointmentText', false)
          .set('updatingAppointmentTextError', action.error)
          .set('appointmentText', fromJS({}));
      });

    case SET_BOOKING_FLOW:
      return state.withMutations(s => {
        s.set('bookingFlow', action.flowType);
      });

    case SET_BOOKING_ATTRIBUTION:
      return state.withMutations(s => {
        s.set('bookingAttribution', fromJS(action.attribution || {}));
      });

    case SET_BUYING_REGULAR_MEMBERSHIP_FLOW:
      return state.withMutations(s => {
        s.set(
          'isBuyingRegularMembershipFlow',
          action.isBuyingRegularMembershipFlow,
        );
      });

    case FETCH_USER_COMPLETED_APPOINTMENTS:
      return state.withMutations(s => {
        s.set('fetchingUserCompletedAppointments', true)
          .set('fetchingUserCompletedAppointmentsError', null)
          .set('userCompletedAppointments', fromJS([]));
      });

    case FETCH_USER_COMPLETED_APPOINTMENTS_SUCCESS:
      return state.withMutations(s => {
        s.set('fetchingUserCompletedAppointments', false)
          .set('fetchingUserCompletedAppointmentsError', null)
          .set('userCompletedAppointments', fromJS(action.result));
      });

    case FETCH_USER_COMPLETED_APPOINTMENTS_FAILURE:
      return state.withMutations(s => {
        s.set('fetchingUserCompletedAppointments', false)
          .set('fetchingUserCompletedAppointmentsError', action.error)
          .set('userCompletedAppointments', fromJS([]));
      });

    // My Appointments
    case FETCH_APPOINTMENTS:
      return state.withMutations(s => {
        s.set('fetchingAppointments', true)
          .set('fetchingAppointmentsError', null)
          .set('myAppointments', fromJS([]));
      });

    case FETCH_APPOINTMENTS_SUCCESS:
      return state.withMutations(s => {
        s.set('fetchingAppointments', false)
          .set('fetchingAppointmentsError', null)
          .set('myAppointments', fromJS(action.result));
      });

    case FETCH_APPOINTMENTS_FAILURE:
      return state.withMutations(s => {
        s.set('fetchingAppointments', false)
          .set('fetchingAppointmentsError', action.error)
          .set('myAppointments', fromJS([]));
      });

    // Status
    case FETCH_STATUS:
      return state.withMutations(s => {
        s.set('fetchingStatus', true)
          .set('fetchingStatusError', null)
          .set('statusRequestId', (s.get('statusRequestId') || 0) + 1);
      });

    case FETCH_STATUS_SUCCESS:
      return state.withMutations(s => {
        s.set('fetchingStatus', false)
          .set('fetchingStatusError', null)
          .set('myStatus', fromJS(action.result));
      });

    case FETCH_STATUS_FAILURE:
      return state.withMutations(s => {
        s.set('fetchingStatus', false).set('fetchingStatusError', action.error);
      });

    case CANCEL_USER_APPOINTMENT:
      return state.withMutations(s => {
        s.set('cancellingUserAppointment', true)
          .set('cancellingUserAppointmentError', null)
          .set('cancelUserAppointmentResult', fromJS({}));
      });

    case CANCEL_USER_APPOINTMENT_SUCCESS:
      return state.withMutations(s => {
        s.set('cancellingUserAppointment', false)
          .set('cancellingUserAppointmentError', null)
          .set('cancelUserAppointmentResult', fromJS(action.result));
      });

    case CANCEL_USER_APPOINTMENT_FAILURE:
      return state.withMutations(s => {
        s.set('cancellingUserAppointment', false)
          .set('cancellingUserAppointmentError', action.error)
          .set('cancelUserAppointmentResult', fromJS({}));
      });

    case SET_FILTER_STATE:
      return state.withMutations(s => {
        s.set('filterState', action.filterState);
      });

    case CLEAR_FILTER_STATE:
      return state.withMutations(s => {
        s.set('filterState', {});
      });

    case SET_CURRENT_THERAPIST_CLICKED:
      return state.withMutations(s => {
        s.set('currentTherapistClicked', action.currentTherapistClicked);
      });

    case CLEAR_CURRENT_THERAPIST_CLICKED:
      return state.withMutations(s => {
        s.set('currentTherapistClicked', {});
      });

    case SET_CURRENT_SELECTED_DATE:
      return state.withMutations(s => {
        s.set('currentSelectedDate', action.currentSelectedDate);
      });

    case CLEAR_CURRENT_SELECTED_DATE:
      return state.withMutations(s => {
        s.set('currentSelectedDate', null);
      });

    case SET_ENTERED_PHONE_NUMBER:
      return state.withMutations(s => {
        s.set('enteredPhoneNumber', action.enteredPhoneNumber);
      });

    case CLEAR_ENTERED_PHONE_NUMBER:
      return state.withMutations(s => {
        s.set('enteredPhoneNumber', null);
      });

    case SET_APPOINTMENT_NET_VALUE:
      return state.withMutations(s => {
        s.set('appointmentNetValue', action.appointmentNetValue);
      });

    case CLEAR_APPOINTMENT_NET_VALUE:
      return state.withMutations(s => {
        s.set('appointmentNetValue', null);
      });

    case SET_ENTERED_PROMO_CODE:
      return state.withMutations(s => {
        s.set('enteredPromoCode', action.enteredPromoCode);
      });

    case CLEAR_ENTERED_PROMO_CODE:
      return state.withMutations(s => {
        s.set('enteredPromoCode', null);
      });

    case RETRY_APPOINTMENT_CHARGE:
      return state.withMutations(s => {
        s.set('retryingAppointmentCharge', true)
          .set('retryingAppointmentChargeError', null)
          .set('retryAppointmentChargeResult', fromJS({}));
      });

    case RETRY_APPOINTMENT_CHARGE_SUCCESS:
      return state.withMutations(s => {
        s.set('retryingAppointmentCharge', false)
          .set('retryingAppointmentChargeError', null)
          .set('retryAppointmentChargeResult', fromJS(action.result));
      });

    case RETRY_APPOINTMENT_CHARGE_FAILURE:
      return state.withMutations(s => {
        s.set('retryingAppointmentCharge', false)
          .set('retryingAppointmentChargeError', action.error)
          .set('retryAppointmentChargeResult', fromJS({}));
      });

    case APPLY_REFERRAL:
      return state.withMutations(s => {
        s.set('applyReferral', true);
      });

    case APPLY_REFERRAL_SUCCESS:
      return state.withMutations(s => {
        s.set('applyReferral', false);
        s.set('referralResult', action.result);
      });

    case FETCH_NEAREST_LOCATION:
      return state.withMutations(s => {
        s.set('fetchingNearestLocations', true)
          .set('fetchingNearestLocationsError', null)
          .set('nearestLocations', fromJS({}));
      });

    case FETCH_NEAREST_LOCATION_SUCCESS:
      return state.withMutations(s => {
        s.set('fetchingNearestLocations', false)
          .set('fetchingNearestLocationsError', null)
          .set('nearestLocations', fromJS(action.result));
      });

    case FETCH_NEAREST_LOCATION_FAILURE:
      return state.withMutations(s => {
        s.set('fetchingNearestLocations', false)
          .set('fetchingNearestLocationsError', action.error)
          .set('nearestLocations', fromJS({}));
      });

    case CLEAR_NEAREST_LOCATIONS:
      return state.withMutations(s => {
        s.set('nearestLocations', {});
      });

    case GET_LIABILITY_WAIVER:
      return state.withMutations(s => {
        s.set('fetchingLiabilityWaiver', true)
          .set('fetchingLiabilityWaiverError', null)
          .set('liabilityWaiver', fromJS({}));
      });

    case GET_LIABILITY_WAIVER_SUCCESS:
      return state.withMutations(s => {
        s.set('fetchingLiabilityWaiver', false)
          .set('fetchingLiabilityWaiverError', null)
          .set('liabilityWaiver', fromJS(action.result));
      });

    case GET_LIABILITY_WAIVER_FAILURE:
      return state.withMutations(s => {
        s.set('fetchingLiabilityWaiver', false)
          .set('fetchingLiabilityWaiverError', action.error)
          .set('liabilityWaiver', fromJS({}));
      });

    case SEND_SIGNATURE:
      return state.withMutations(s => {
        s.set('sendingSignature', true)
          .set('sendingSignatureError', null)
          .set('signature', fromJS({}));
      });

    case SEND_SIGNATURE_SUCCESS:
      return state.withMutations(s => {
        s.set('sendingSignature', false)
          .set('sendingSignatureError', null)
          .set('signature', fromJS(action.result));
      });

    case SEND_SIGNATURE_FAILURE:
      return state.withMutations(s => {
        s.set('sendingSignature', false)
          .set('sendingSignatureError', action.error)
          .set('signature', fromJS({}));
      });

    case SUGGESTED_TIP_AMOUNT:
      return state.withMutations(s => {
        s.set('fetchingSuggestedTipAmount', true);
      });

    case SUGGESTED_TIP_AMOUNT_SUCCESS:
      return state.withMutations(s => {
        s.set('fetchingSuggestedTipAmount', false).set(
          'suggestedTipAmount',
          action.result,
        );
      });

    case SUGGESTED_TIP_AMOUNT_FAILURE:
      return state.withMutations(s => {
        s.set('fetchingSuggestedTipAmount', false).set(
          'suggestedTipAmountError',
          action.error,
        );
      });

    case GET_IP_ADDRESS:
      return state.withMutations(s => {
        s.set('fetchingIpAddress', true);
      });

    case GET_IP_ADDRESS_SUCCESS:
      return state.withMutations(s => {
        s.set('fetchingIpAddress', false).set('ipAddress', action.result);
      });

    case GET_IP_ADDRESS_FAILURE:
      return state.withMutations(s => {
        s.set('fetchingIpAddress', false).set('ipAddressError', action.error);
      });

    case GEOLOCATION_API_STATUS:
      return state.withMutations(s => {
        s.set('geoLocationStatus', action.status);
      });

    case SEND_REQUIRED_GOVT_INFO:
      return state.withMutations(s => {
        s.set('sendingRequiredGovtInfo', true)
          .set('sendingRequiredGovtInfoError', null)
          .set('requiredGovtInfo', fromJS([]));
      });

    case SEND_REQUIRED_GOVT_INFO_SUCCESS:
      return state.withMutations(s => {
        s.set('sendingRequiredGovtInfo', false)
          .set('sendingRequiredGovtInfoError', null)
          .set('requiredGovtInfo', fromJS(action.result));
      });

    case SEND_REQUIRED_GOVT_INFO_FAILURE:
      return state.withMutations(s => {
        s.set('sendingRequiredGovtInfo', false)
          .set('sendingRequiredGovtInfoError', action.err)
          .set('requiredGovtInfo', fromJS([]));
      });

    case CLEAR_APPOINTMENT_DATA:
      return initialState;

    case 'RESET_ACTION':
      return initialState;

    default:
      return state;
  }
}

export default appointmentReducer;
